import { Component, ElementRef, inject, Input, OnInit, TemplateRef, ViewChild } from '@angular/core'; import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ListTableComponent } from '@ppl/ui';
import { NgZorroModule } from '../../../shared/modules/ng-zorro/ng-zorro.module';
import { AccordionComponent } from '@ppl/ui';
import { ButtonComponent } from '@ppl/ui';
import { AssociationDetailsComponent } from './association-details/association-details.component';
import { BaseComponent } from '../../../shared/utils/base.component';
import { ADDITIONAL_ATTRIBUTE_MAP, ENROLLMENT_TYPE_BACKEND_MAPPINGS, ENROLLMENT_TYPE_UI_TO_BACKEND_MAPPINGS, PROVIDER_TYPES, ProviderCode, RADIO_YES_NO_OPTIONS, STATIC_DATA, STATIC_JSON_DATA_PATH } from '../../../shared/constants/static-data.constants';
import { SectionsService } from '../../../services/sections.service';
import { ReferralDataService } from '../../../services/referral-data.service';
import { EnrollmentDataService } from '../../../services/enrollment-data.service';
import { LoggerService } from '../../../shared/services/logger.service';
import { ProviderAssociationsComponent } from './provider-associations/provider-associations.component';
import { PopupDialogComponent } from '@ppl/ui';
import { ModalComponent } from '@ppl/ui';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { performValidation } from '../../../shared/utils/validation.util';
import { TableRowActionsModel } from '../../../shared/interfaces/list.interface';
import { TableRowActions } from '../../../shared/interfaces/actions';
import { AuthorizeDirective } from '../../../shared/authorization/authorize.directive.';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { MEMBER_VIEW_PAGE_IDS, TABS } from '../../../shared/constants/page.constants';
import { LeadDetailsService } from '../../../services/lead-details.service';
import { Router } from '@angular/router';
import { AuthorizationUtility } from '../../../shared/authorization/auth.utility';
import { environment } from '../../../../environments/environment';
import { UserService } from '../../../services/user.service';
import { StorageService } from '../../../services/storage.service';
import { DatepickerComponent } from '@ppl/ui';
import { DialogConfig, DialogService } from '../../../shared/services/dialog.service';
import { FocusTrapDirective } from '../../../shared/directives/focus-trap.directive';
import { DropdownSelectComponent } from '@ppl/ui';
import { NotificationService } from '../../../shared/services/notification.service';

@Component({
  selector: 'ppl-associations',
  standalone: true,
  imports: [ListTableComponent, CommonModule, NgZorroModule, ReactiveFormsModule, AccordionComponent,
    ButtonComponent, AssociationDetailsComponent, ProviderAssociationsComponent, DatepickerComponent,
    NzDatePickerModule, ModalComponent, NzAlertModule, PopupDialogComponent, AuthorizeDirective,
    FocusTrapDirective, DropdownSelectComponent
  ],
  templateUrl: './associations.component.html',
  styleUrl: './associations.component.css'
})
export class AssociationsComponent extends BaseComponent implements OnInit {

  // mode is meant for internal it can be updated
  @Input() mode = 'read';

  // manually override the component to make it readonly
  @Input() readonly = false;
  radioOptions = RADIO_YES_NO_OPTIONS;
  newContactForm!: FormGroup;
  show = false;
  tabId = TABS.Associations;
  minStartDate?: Date;
  maxEndDate?: Date;
  restoreMinStartDate?: Date;
  isIfProviderType?: boolean;

  associationDetailsData: any = null;
  prvdrAssociations: any = [];
  prvdrAssociationsStatus: any = [];

  cols: any[] = [];
  statusCols: any[] = [];
  selectedOption = '';

  actions: any = {
    "Add Status": false,
  }

  entry = '';
  consumerData: any;
  customErrorMessage: string = '';
  showModal: any;
  modalBody = '';
  program: any;
  selectedAssociationId = '';
  selectedProviderId: any = '';
  statusAddErrorMessage = 'Add Status Failed';
  statusUpdateErrorMessage = 'Update Failed';
  showStatusAddErrorMessage: boolean = false;
  enrollmentStatus!: FormGroup;
  private dialogSvc = inject(DialogService);
  @ViewChild('manageStatusDialog') manageStatus!: TemplateRef<any>;
  @ViewChild('inactivateConfirmationDialog') inactivateConfirmationDialog!: TemplateRef<any>;
  @ViewChild('addStatusBtn') addStatusBtn!: ElementRef;

  statusEntries: any[] = [];

  allowMultiple = {
    AR: true,
    EMP: true,
    IR: true,
    IC: true,
    VE: true,
    IF: true,
    POA: true,
    CNV: true,
    LG: true
  };

  allowedStatus: any[] = [];
  disableAddStatus = false;
  disableStatus = false;
  statusReasons: any[] = [];
  generalReasonList: any[] = [];
  disAssociateReasonList: any[] = [];
  showMoveToInPPLReviewButton = false;
  participantStatus = '';
  actionButtons: TableRowActionsModel = new TableRowActions();
  isParticipant = true;
  leadId: any;
  isAssociationsEditable: boolean = false;
  canShowStatus: boolean = false;
  userDetails: any;
  pageId = MEMBER_VIEW_PAGE_IDS[this.userService.getFirstSegment()!];
  isRecieveGoodsAndServicesOnly: boolean = true;
  isAssociationStatusEditable: boolean = false;
  canDeleteAssociation: boolean = false;
  isEmploymentDateStatus: boolean = false;
  isParticipantMinor: boolean = false;
  selectedAssociationStartDate: string = '';
  selectedProviderType: string = '';
  private arEnrAssociationStatusList: any[] = [];
  private participantEnrStatusList: any[] = [];
  private providerEnrStatusList: any[] = [];
  private canBackDateAssociationStartDate: boolean = false;
  constructor(
    private sectionsService: SectionsService,
    private fb: FormBuilder,
    private referralDataService: ReferralDataService,
    private enrollmentDataService: EnrollmentDataService,
    private logger: LoggerService,
    private leadDetailsService: LeadDetailsService,
    private router: Router,
    private authUtility: AuthorizationUtility,
    private userService: UserService,
    private storageService: StorageService,
    private notificationService: NotificationService,
    private sectionService: SectionsService,
  ) {
    super();
  }

  activeKeys: string[] = ['1', '2', '3', '4', '5', '6', '7'];
  allPanelsExpanded = false;
  showModifiedBy = true;
  canManageEmployer = true;
  canManageConsumer = true;
  ngOnInit(): void {
    this.entry = this.userService.getLeadEntry() ?? '';
    this.sectionsService.setFlow(this.entry);
    this.isParticipant = this.entry === 'participantEnrollment';
    this.isAssociationsEditable = this.readonly ? false : this.authUtility.isSectionEditable(this.pageId, this.tabId, TABS.Associations);
    this.canShowStatus = this.readonly ? false : this.authUtility.isSectionVisible(this.pageId, this.tabId, 'AssociationsStatus');
    this.canManageEmployer = this.pageId ? this.authUtility.isButtonVisible(this.pageId, 'ManageEmployer') : true;
    this.canManageConsumer = this.pageId ? this.authUtility.isButtonVisible(this.pageId, 'ManageConsumer') : true;
    this.canDeleteAssociation = this.authUtility.isSectionDeletable(this.pageId, this.tabId, 'Associations');
    this.canBackDateAssociationStartDate = this.pageId ? this.authUtility.isButtonVisible(this.pageId, 'EditActiveAssociationStatusStartDate') : false;
    this.newContactForm = this.fb.group({
      newEmployer: ['No'],
      newAuthRep: ['No'],
      newVendor: ['No'],
      newProvider: ['No'],
      newContractor: ['No'],
      newPOA: ['No'],
      newLegalGuardian: ['No'],
    });
    const providerType = this.sectionsService.getEnrollmentType();
    this.isIfProviderType = providerType.includes(ENROLLMENT_TYPE_BACKEND_MAPPINGS['IF']);
    this.program = this.userService.getSelectedProgram();
    this.leadId = this.userService.getSelectedLead();
    const steps = this.sectionsService.getSectionData(this.program.program_code);
    this.secData = steps[this.isParticipant ? 'associations' : 'enrollment_status'];
    this.userDetails = this.userService.getUserDetails();

    const userType = this.userDetails?.usertype_lkp?.toLowerCase();
    if (userType && ['provider', 'participant'].includes(userType)) {
      this.showModifiedBy = false;
    }

    this.arEnrAssociationStatusList = this.lookupService.getLookupValue('ar_enr_association_status');
    this.participantEnrStatusList = this.lookupService.getLookupValue('ENR_COV_Gaps');
    this.providerEnrStatusList = this.lookupService.getLookupValue('prv_enr_association_status');
    this.statusEntries = this.isParticipant ? this.participantEnrStatusList : this.providerEnrStatusList;
    this.disAssociateReasonList = this.sortOtherOptionToLastEntry(this.lookupService.getLookupValue('Disassociation Reason'));
    this.generalReasonList = this.lookupService.getLookupValue('enr_status_reason');
    const isInRole = this.program?.roles.some((role: any) => role.role_name === 'PPL Staff Tier 1') && userType === 'fms';
    if (isInRole) {
      this.statusEntries = this.statusEntries.filter((e) => e.lkpValueCode != 'Paperwork Complete');
    }
    this.getConsumerDetails();
    this.createFormGroup();

    const controls = [
      'newEmployer',
      'newAuthRep',
      'newProvider',
      'newVendor',
      'newIndependentFacilitator',
      'newContractor',
      'newLegalGuardian',
      'newPOA',
    ];

    controls.forEach((control) => {
      this.newContactForm.get(control)?.valueChanges.subscribe((value) => {
        this.onRadioChange(control, value);
      });
    });

    this.getGridHeaders()
    this.getAssociationDetails(this.program.program_code, this.leadId);
    this.enrollmentDataService.getParticipantAssocChanged().subscribe(() => {
      this.getAssociationDetails(this.program.program_code, this.leadId);
    })
    this.enrollmentStatus.get('endDate')?.valueChanges.subscribe(() => {
      this.updateMinStartDate();
    });
    this.enrollmentStatus.get('startDate')?.valueChanges.subscribe(() => {
      this.updateMaxEndDate();
    });


    this.generalReasonList = this.lookupService.getLookupValue('enr_status_reason');
    this.enrollmentStatus.get('status')?.valueChanges.subscribe(() => {
      const statusValue = this.enrollmentStatus.get('status')?.value;

      if (this.mode !== 'edit') {
        this.enrollmentStatus.get('startDate')?.reset(null, { emitEvent: false });
        this.enrollmentStatus.get('endDate')?.reset(null, { emitEvent: false });
        this.enrollmentStatus.get('reason')?.reset(null);
        this.enrollmentStatus.get('comment')?.reset(null);
      }

      this.isEmploymentDateStatus = statusValue === 'EmploymentDate';
      if (this.isEmploymentDateStatus) {
        this.enrollmentStatus.get('endDate')?.disable();
        this.enrollmentStatus.get('reason')?.disable();
        this.enrollmentStatus.get('startDate')?.enable();
        this.enrollmentStatus.get('comment')?.enable();
      } else {
        this.enrollmentStatus.get('endDate')?.enable();
        this.enrollmentStatus.get('reason')?.enable();
      }

      if (this.isDisassociatedStatus(statusValue)) {
        // Disassociated: startDate enabled & mandatory, endDate disabled & optional.
        // In edit mode, the startDate value is already set via patchValue from the table row.
        this.enrollmentStatus.get('startDate')?.enable();
        this.enrollmentStatus.get('startDate')?.setValidators([Validators.required]);
        this.enrollmentStatus.get('startDate')?.updateValueAndValidity();
        this.enrollmentStatus.get('endDate')?.disable();
        this.enrollmentStatus.get('endDate')?.clearValidators();
        this.enrollmentStatus.get('endDate')?.updateValueAndValidity();
      } else {
        this.enrollmentStatus.get('startDate')?.enable();
        this.enrollmentStatus.get('startDate')?.clearValidators();
        this.enrollmentStatus.get('startDate')?.updateValueAndValidity();

        if (statusValue === 'DisEnroll') {
          this.enrollmentStatus.get('endDate')?.setValidators([Validators.required]);
        } else {
          this.enrollmentStatus.get('endDate')?.clearValidators();
        }
        this.enrollmentStatus.get('endDate')?.updateValueAndValidity();
      }

      this.applyStartDateBackDatingRule(statusValue);

      if (!this.isParticipant) {
        this.updateReasonList(statusValue);
      }

      const selectedName = this.statusEntries.find((s: any) => s.lkpValueCode === statusValue)?.lkpValueName;
      if (selectedName === STATIC_DATA.ASSOCIATION_RESTORE_STATUS || selectedName === STATIC_DATA.ASSOCIATION_REHIRE_STATUS) {
        this.restoreMinStartDate = this.getLatestDisassocStartDate() ?? undefined;
      } else {
        this.restoreMinStartDate = undefined;
      }
    });

    const demographicData = this.referralDataService.demographicData;
    if (demographicData?.additionalAttributes?.length > 0) {
      const recieveGoodsAndServicesAttribute = demographicData.additionalAttributes.filter((data: any) => data.additionalAttributesId === ADDITIONAL_ATTRIBUTE_MAP.recieveGoodsAndServices);
      if (recieveGoodsAndServicesAttribute?.length > 0) {
        const mostRecentRecieveGoodsAndServices = recieveGoodsAndServicesAttribute.reduce((latest: any, current: any) => {
          return this.parseDate(current.modifiedDate) > this.parseDate(latest.modifiedDate) ? current : latest;
        });
        this.isRecieveGoodsAndServicesOnly = mostRecentRecieveGoodsAndServices?.value === 'Yes' ? true : false;
      } else {
        this.isRecieveGoodsAndServicesOnly = false;
      }
    }
  }

  parseDate(dateStr: string) {
    const [datePart, timePart] = dateStr.split(" ");
    const [h, m, s] = timePart.split(":").slice(0, 3);
    return new Date(`${datePart} ${h}:${m}:${s}`);
  }

  getAssociationDetails(program_code: string, leadId: any, isWriteRequest = false) {
    const participantId = !this.isParticipant ? this.storageService.getSelfEmployerParticipantId() : undefined;
    this.enrollmentDataService.getAssociationsDetails(program_code, leadId, this.isParticipant, isWriteRequest, participantId).subscribe((response: any) => {
      console.log(response.responsedata);
      const data = response.responsedata;
      // participantAssociations
      if (this.isParticipant) {
        this.associationDetailsData = {};
        for (const key in PROVIDER_TYPES) {
          this.associationDetailsData[key] = data[key] || [];
        }
        this.checkParticipantMinorStatus();
      } else {
        this.prvdrAssociations = data.participantAssociations;
        const employerAssociations = data.employerAssociations || [];
        if (employerAssociations.length > 0) {
          const additionalcolumns = [{
            field: "employerPplId",
            header: "Employer PPL ID",
            jsonpath: "employerPplId",
            isDisplayedAtHeader: "y",
            isSearchable: "y"
          },
          {
            field: "employerName",
            header: "Employer Name",
            jsonpath: "employerName",
            isDisplayedAtHeader: "y",
            isSearchable: "y"
          },
          {
            field: "relationToEmployer",
            header: "Relation to Employer",
            jsonpath: "relationToEmployer",
            isDisplayedAtHeader: "y",
            isSearchable: "y"
          },
          {
            field: "employerStartDate",
            header: "Employer Start Date",
            jsonpath: "employerStartDate",
            isDisplayedAtHeader: "y",
            isSearchable: "y"
          }];

          additionalcolumns.forEach(col => {
            if (!this.cols.some(existingCol => existingCol.field === col.field)) {
              this.cols.push(col);
            }
          });
        }
        this.prvdrAssociations?.forEach((association: any) => {
          association.participantName = association.participantFirstName + ' ' + association.participantLastName;
          // set assocaition details for employer association
          const employerAssociation = employerAssociations.find((empAssoc: any) => empAssoc.participantId === association.participantId);
          if (employerAssociation) {
            association.employerId = employerAssociation.providerId;
            association.employerPplId = employerAssociation.providerPplId;
            association.employerName = employerAssociation.providerFirstName + ' ' + employerAssociation.providerLastName;
            association.relationToEmployer = association?.relationToEmployer ? `${association.relationToEmployer?.charAt(0).toUpperCase() + association.relationToEmployer?.slice(1)}` : '-';
            association.participantRelationToEmployer = employerAssociation.relationToParticipant;
            association.employerStartDate = employerAssociation.associationStartDate;
          }
          else {
            association.employerPplId = '-';
            association.employerName = '-';
            association.relationToEmployer = '-';
            association.employerStartDate = '-';
          }

          association.actions = {
            showStatus: this.canShowStatus,
            // Set per row, not on the grid: ppl-list-table ORs actionButtons.delete with this,
            // so a grid-level flag would offer Delete on every association.
            delete: this.canDeleteAssociation && this.deletableAssociationStatuses.includes(association.associationStatus)
          };
          
          const isassociationactive = association.associationStatus === 'Association Active' || association.associationStatus === 'Registration Active' || association.associationStatus === 'Association Active with Gap' || association.associationStatus === 'Paperwork Complete';
          if (isassociationactive) {
            if (association.providerType === 'EMP' || association.providerType === 'AR' || association.providerType === 'POA' || association.providerType === 'LG' || association.providerType === 'CNV') {
              association.actions.manageConsumer = this.canManageConsumer;
            }

            // Independent Facilitator gets a way into the participant too, but only to Service
            // Authorizations / To Do List / Provider Services (read-only) — see action().
            // TODO: reusing manageConsumer means the button reads "Manage Participant"; switch to
            // the dedicated view action once @ppl/ui exposes one.
            if (association.providerType === 'IF') {
              association.actions.manageConsumer = this.canManageConsumer;
            }

            const isProviderForParticipant = this.prvdrAssociations.some((a: any) =>
              a.participantId === association.participantId && ['IR', 'IC', 'VE', 'IF'].includes(a.providerType));

            if ((association.providerType === "POA" || association.providerType === "CNV" || association.providerType === 'LG') && association.participantRelationToEmployer === "Self (Participant)" && !isProviderForParticipant) {
              association.actions.manageEmployer = this.canManageEmployer;
            }
          }

          if (association.associationStatus == 'Disassociated') {
            association.actions.manageConsumer = false;
            association.actions.manageEmployer = false;
          }
        });
      }
    });
  }

  getProviderAssoc(program_code: string, leadId: any) {
    this.enrollmentDataService.fetchProviderAssociations(program_code, leadId).subscribe((response: any) => {
      console.log(response);

    })
  }

  async getGridHeaders() {
    try {
      if (this.entry) {
        const tempCols = await this.sectionsService.getJsonConfigurationData(
          this.entry === 'participantEnrollment' ? STATIC_JSON_DATA_PATH.ASSOCIATIONS_DETAILS_HEADERS : STATIC_JSON_DATA_PATH.PROVIDER_ASSOCIATIONS_HEADERS, this.entry
        );
        console.log(tempCols.columns);
        this.cols = this.isIfProviderType ? tempCols.columns.filter((col: any) => { return col.field !== 'relationToParticipant' }) : tempCols.columns;

        if (this.entry != 'participantEnrollment') {
          const statusCols = await this.sectionsService.getJsonConfigurationData(STATIC_JSON_DATA_PATH.PROVIDER_ASSOCIATIONS_STATUS_HEADERS, this.entry);
          this.statusCols = statusCols.enrollmentStatus.columns;
          const userType = this.userDetails?.usertype_lkp?.toLowerCase();
          if (userType && ['provider', 'participant'].includes(userType)) {
            this.statusCols = this.statusCols.filter((data: any) => data.jsonpath !== 'modifiedBy');
          }
        }
      }
    } catch (e) {
      this.logger.debug('Communication logs - Error in getting column data', e);
    }

  }

  /**
   * @param facilitatorView when true the participant opens in the Independent Facilitator's
   *        restricted view — Service Authorizations, To Do List and Provider Services only, all
   *        read-only. Carried in router state, which member-view already reads for navigateToTab.
   */
  goToConsumer(consumerDetail: any, facilitatorView = false) {
    const program = this.userService.getSelectedProgram();
    this.userService.setLeadEntry('participantEnrollment');
    this.sectionsService.setFlow('participantEnrollment');
    this.referralDataService.clearReferrralData();
    this.userService.setSelectedLead(consumerDetail.participantId);
    this.leadDetailsService
      .fetchLeadDetailsApi(
        'participantEnrollment',
        program?.program_code ?? '',
        consumerDetail.participantId
      )
      .subscribe((data: any) => {
        this.referralDataService.setReferralDetails(data.responsedata);
        if (data?.responsedata?.infoData?.applicationStatus == "In Progress" || data?.responsedata?.infoData?.applicationStatus == "New Application") {
          if (this.readonly) {
            this.notificationService.error('View Only', 'Cannot open in-progress applications in view-only mode.');
            return;
          }
          setTimeout(() => {
            this.storageService.setShowOtherSignatures(true);
            this.storageService.setParticipantId(data?.responsedata?.infoData.participantId);
            this.storageService.setParticipantPPLId(data.responsedata?.infoData.participantPPLId);
            this.storageService.setTrackingNumber(data.responsedata?.infoData.trackingNumber);
            this.router.navigate(['/newReferral']);
          }, 200);
        } else {
          this.userService.setFirstSegment('participantEnrollmentList');
          this.storageService.setShowOtherSignatures(true);
          const providerType = this.sectionsService.getEnrollmentType();
          this.sectionsService.setEnrollmentType('[]');
          setTimeout(() => {
            this.router.navigate(['/home/participantEnrollmentList/details/'],
              {
                state: {
                  navigateToTab: facilitatorView ? 'Authorizations' : 'summary',
                  leadId: this.leadId,
                  providerType: providerType,
                  facilitatorView: facilitatorView
                }
              }
            );
          }, 200);
        }
      });

  }

  goToEmployer(consumerDetail: any) {
    this.goToProvider(STATIC_DATA.PROVIDER_ENROLLMENT, this.program.program_code, consumerDetail.employerId, consumerDetail.participantId);
  }

  goToProvider(entry: string, program_code: string, referenceId: string, participantId?: string) {
    const currentEnrollmentType = this.sectionsService.getEnrollmentType();

    this.leadDetailsService
      .fetchLeadDetailsApi(
        entry,
        program_code,
        Number(referenceId)
      )
      .subscribe((data) => {

        if (data?.responsedata?.infoData?.applicationStatus != "In Progress" && data?.responsedata?.infoData?.applicationStatus != "New Application") {
          this.userService.setFirstSegment('providerEnrollmentList');
          setTimeout(() => {

            if (entry === STATIC_DATA.PROVIDER_ENROLLMENT) {
              const providerTypesList = (data?.responsedata?.participantAssociations ?? []).map((provider: any) => ENROLLMENT_TYPE_BACKEND_MAPPINGS[provider.providerType]).filter(Boolean);
              this.storageService.setProviderId(data?.responsedata?.providerId);
              this.storageService.setTrackingNumber(data?.responsedata?.trackingNumber);
              this.storageService.setProviderPPLId(data?.responsedata?.providerPPLId);
              this.sectionService.setEnrollmentType(JSON.stringify(providerTypesList));
            }

            this.referralDataService.clearReferrralData();
            if (participantId) {
              this.storageService.setSelfEmployerParticipantId(participantId);
            }
            this.userService.setLeadEntry(entry);
            this.sectionService.setFlow(entry);
            this.userService.setSelectedLead(referenceId);
            this.router.navigate(['/home/providerEnrollmentList/details/summary'],
              {
                state: {
                  navigateToTab: 'associations',
                  leadId: this.leadId,
                  providerType: currentEnrollmentType
                }
              }
            );
          }, 200);
        } else {
          this.notificationService.alert('info', 'Enrollment Incomplete', 'The employer has not yet completed their enrollment.');
        }
      });
  }

  action(event: any): void {
    this.logger.debug('Action', event);

    if (event.action == 'showStatus') {
      this.showStatusAddErrorMessage = false;
      const data = event.data;
      this.modalBody = 'Enrollment Dates and Status - ' + data.participantFirstName + ' ' + data.participantLastName + ' (' + data.participantPplId + ")";
      this.showModal = true;
      this.selectedAssociationId = data.participantProviderAssociationId;
      this.selectedProviderId = data.providerId;
      this.selectedAssociationStartDate = data.associationStartDate ?? '';
      this.selectedProviderType = data.providerType ?? '';
      if ([ENROLLMENT_TYPE_UI_TO_BACKEND_MAPPINGS['authRepresentative'], ENROLLMENT_TYPE_UI_TO_BACKEND_MAPPINGS['poa'],
      ENROLLMENT_TYPE_UI_TO_BACKEND_MAPPINGS['conservator'], ENROLLMENT_TYPE_UI_TO_BACKEND_MAPPINGS['legalGuardian']
      ].includes(data.providerType)) {
        this.statusEntries = this.arEnrAssociationStatusList;
      } else {
        this.statusEntries = this.isParticipant ? this.participantEnrStatusList : this.providerEnrStatusList;
      }

      this.getAssociationStatus();
      this.updateAssociationStatus(data.associationStatus);
      const dialogConfig: DialogConfig = {
        title: this.modalBody,
        okText: 'Save',
        size: 'xx-large',
        position: 'top',
        showClose: true,
        showButtons: false,
      };

      this.dialogSvc.openDialog(
        this.manageStatus,
        dialogConfig,
        () => this.handleDialogCancel(),
        () => this.handleDialogCancel()
      );
    }
    else if (event.action === 'delete') {
      this.openInactivateConfirmation(event.data);
    }
    else if (event.action == 'manageConsumer') {
      const data = event.data;
      // An Independent Facilitator only gets the restricted, read-only view of the participant.
      this.goToConsumer(data, data?.providerType === 'IF');
    }
    else if (event.action == 'manageEmployer') {
      const data = event.data;
      this.goToEmployer(data);
    }

    if (event && event.action === 'edit') {
      this.mode = 'edit';
      if (event?.data) {
        if ([ENROLLMENT_TYPE_UI_TO_BACKEND_MAPPINGS['authRepresentative'], ENROLLMENT_TYPE_UI_TO_BACKEND_MAPPINGS['poa'],
        ENROLLMENT_TYPE_UI_TO_BACKEND_MAPPINGS['conservator'], ENROLLMENT_TYPE_UI_TO_BACKEND_MAPPINGS['legalGuardian']
        ].includes(this.selectedProviderType)) {
          this.statusEntries = this.arEnrAssociationStatusList;
        } else {
          this.statusEntries = this.isParticipant ? this.participantEnrStatusList : this.providerEnrStatusList;
        }

        
        this.allowedStatus = [...this.statusEntries];
        const data = JSON.parse(JSON.stringify(event?.data));
        data.startDate = this.dateFormatter.stringToDate(data.startDate);
        if (data.endDate) {
          data.endDate = this.dateFormatter.stringToDate(data.endDate);
        }

        this.enrollmentStatus.patchValue(data);
      }      
    }

    // if not particpant and not providertype is not IR hide the 'EmploymentDate' status option
    if (!this.isParticipant && this.selectedProviderType !== 'IR') {
      this.statusEntries = this.statusEntries.filter((status) => status.lkpValueCode !== 'EmploymentDate');
      this.allowedStatus = this.allowedStatus.filter((status) => status.lkpValueCode !== 'EmploymentDate');
    }
  }

  /**
   * Confirms before inactivating an association. Only rows in an in-flight application status
   * offer this action, so the row carries the status the inactivation is recorded against.
   */
  openInactivateConfirmation(data: any) {
    const dialogConfig: DialogConfig = {
      title: 'Delete Association',
      okText: 'Ok',
      size: 'medium',
      position: 'top',
      showClose: true,
      showButtons: true,
    };

    this.dialogSvc.openDialog(
      this.inactivateConfirmationDialog,
      dialogConfig,
      () => this.inactivateAssociation(data),
      () => { }
    );
  }

  private inactivateAssociation(data: any) {
    this.enrollmentDataService
      .inactivateAssociation(
        this.program?.program_code,
        data?.participantProviderAssociationId,
        data?.associationStatus
      )
      .subscribe(() => {
        this.enrollmentDataService.setParticipantAssocChanged(true);
      });
  }
  
  getConsumerDetails() {
    this.leadDetailsService
      .getLeadDetails(this.entry, this.program.program_code, this.leadId, true)
      .subscribe((data: any) => {
        this.consumerData = data?.responsedata?.infoData;
      });
  }

  /**
   * An association may be deleted only while its application is still in flight. Anything
   * further along has downstream records (timesheets, authorizations) hanging off it.
   */
  private readonly deletableAssociationStatuses = ['In PPL Review', 'In Progress'];
  /**
   * Moving the start date of an existing Paperwork Complete / Association Active record is a
   * separate permission from editing the status itself. Without it both dates stay read-only,
   * so the record cannot be backdated; with it only the start date opens up.
   *
   * Runs after the status rules above, which enable the dates on their own terms.
   */
  private applyStartDateBackDatingRule(statusValue: any): void {
    if (this.mode !== 'edit' || !this.alwaysEditableStatuses.includes(statusValue)) {
      return;
    }

    if (this.canBackDateAssociationStartDate) {
      this.enrollmentStatus.get('startDate')?.enable({ emitEvent: false });
      return;
    }

    this.enrollmentStatus.get('startDate')?.disable({ emitEvent: false });
    this.enrollmentStatus.get('endDate')?.disable({ emitEvent: false });
  }

  /** Statuses whose latest record always allows its start date to be corrected. */
  private readonly alwaysEditableStatuses = ['Paperwork Complete', 'Association Active', 'Association Active with Gap'];

  /** Start date as a sortable number; only ever compared against other rows of this list. */
  private statusStartTime(row: any): number {
    const time = row?.startDate ? new Date(row.startDate).getTime() : NaN;
    return isNaN(time) ? 0 : time;
  }

  /** Rows still open (no end date) first, then most recent start date first within each group. */
  private sortAssociationStatuses(rows: any[]): any[] {
    return [...rows].sort((a: any, b: any) => {
      const aClosed = a?.endDate ? 1 : 0;
      const bClosed = b?.endDate ? 1 : 0;

      return aClosed !== bClosed ? aClosed - bClosed : this.statusStartTime(b) - this.statusStartTime(a);
    });
  }

  /**
   * The original rule, unchanged: a row that has already started and not yet ended, or that
   * starts in the future.
   */
  private isCurrentOrFutureStatus(row: any): boolean {
    const start = this.statusStartTime(row);
    if (!start) {
      return false;
    }

    const now = Date.now();
    const end = row?.endDate ? new Date(row.endDate).getTime() : null;

    const isFuture = now < start;
    const isActive = now > start && (!end || now < end);

    return isFuture || isActive;
  }

  /**
   * Most recent Paperwork Complete / Association Active row, ended or not. Its start date stays
   * correctable even once the row has closed, which the current-or-future rule alone would not
   * allow. Only the latest one qualifies, so a history with several of them offers Edit once.
   */
  private findLatestAlwaysEditableRow(rows: any[]): any {
    return rows
      .filter((row: any) => this.alwaysEditableStatuses.includes(row?.status))
      .reduce(
        (latest: any, row: any) =>
          !latest || this.statusStartTime(row) > this.statusStartTime(latest) ? row : latest,
        null
      );
  }

  getAssociationStatus() {
    this.enrollmentDataService.getAssociationStatus(this.program?.program_code, this.selectedAssociationId).subscribe((data: any) => {
      this.prvdrAssociationsStatus = this.sortAssociationStatuses(data?.responsedata ?? []);

      const latestAlwaysEditableRow = this.findLatestAlwaysEditableRow(this.prvdrAssociationsStatus);

      this.prvdrAssociationsStatus.forEach((data: any) => {
        // Edit is offered to the latest Paperwork Complete / Association Active row whatever its
        // dates, and to any other row under the original current-or-future rule.
        data.actions = {
          edit:
            this.isAssociationStatusEditable &&
            (data === latestAlwaysEditableRow || this.isCurrentOrFutureStatus(data))
        };

        if (data?.reason) {
          let reasonList;
          if (this.isDisassociatedStatus(data.status)) {
            reasonList = this.disAssociateReasonList;
          } else {
            reasonList = this.generalReasonList;
          }

          const reason = reasonList.filter((reason: any) => reason.lkpValueCode === data.reason);
          data.reasonName = reason[0]?.lkpValueName;
        }
      });
    });
  }

  getProviderData(providerCode: string) {
    let data = this.associationDetailsData[providerCode] || [];
    const restoreRehireCodes: ProviderCode[] = ['IR', 'IC', 'VE', 'IF'];
    const isExternalUser = environment.isExternal && this.userDetails?.usertype_lkp?.toLowerCase() != 'state';
    data.forEach((e: any) => {
      // if assocaition is 12/31/2999 then it is not a future disassociation and we should not show the disassociate button
      var isFutureDisassociation = e.associationEndDate && e.associationEndDate != '12/31/2999';
      if (e.associationStatus != 'Disassociated' && !isFutureDisassociation) {
        // External users cannot disassociate an Employer once status is Paperwork Complete.
        const canEditAssociation = this.authUtility.isSectionEditable(this.pageId, this.tabId, 'Associations');
        const blockEmpDisassociation = !canEditAssociation || (isExternalUser && providerCode === 'EMP' && (e.associationStatus === 'Paperwork Complete' || e.associationStatus === 'Association Active with Gap' || e.associationStatus === 'Association Active'));
        e.actions = {
          'showDisassociate': !blockEmpDisassociation
        }
      } else if (restoreRehireCodes.includes(providerCode as ProviderCode) && e.associationStatus === 'Disassociated') {
        const startDate = new Date(e.associationStartDate);
        startDate.setHours(0, 0, 0, 0);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        if (startDate <= today) {
          const diffDays = Math.floor((today.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24));
          e.actions = diffDays < STATIC_DATA.RESTORE_REHIRE_THRESHOLD_DAYS ? { showRestoreAssociation: true } : { showRehireAssociation: true };
        }
      }
    });

    const restrictedProviderCodes: ProviderCode[] = ['AR', 'EMP', 'POA', 'LG'];
    if (data?.length && restrictedProviderCodes.includes(providerCode as ProviderCode)) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const activeCount = data.filter((entry: any) => {
        if (entry.associationStatus !== 'Disassociated') return true;
        if (!entry.associationStartDate) return true;
        const startDate = new Date(entry.associationStartDate);
        startDate.setHours(0, 0, 0, 0);
        return startDate > today;
      }).length;
      const maxActive = providerCode === 'AR' ? 2 : 1;
      this.allowMultiple[providerCode as ProviderCode] = activeCount < maxActive;
    }

    const minorRestrictedCodes: ProviderCode[] = ['POA', 'CNV'];
    if (this.isParticipantMinor && minorRestrictedCodes.includes(providerCode as ProviderCode)) {
      this.allowMultiple[providerCode as ProviderCode] = false;
    }

    return data;
  }

  checkParticipantMinorStatus() {
    const dob = this.referralDataService.demographicData?.dob;
    if (dob) {
      const birthDate = new Date(dob);
      const age = Math.floor((Date.now() - birthDate.getTime()) / (365.25 * 24 * 60 * 60 * 1000));
      this.isParticipantMinor = age < 18;
    }
  }

  getProviderColumns(providerCode: string) {
    let data = this.cols;

    if (providerCode !== 'vendor' && providerCode !== 'IC' && providerCode !== 'IF') {
      data = data.filter((e: any) => e.field !== 'legalName');
    }

    if (providerCode !== 'AR' && providerCode !== 'IR' && providerCode !== 'EMP') {
      data = data.filter((e: any) => e.field !== 'relationToParticipant');
    }

    if (providerCode !== 'EMP') {
      data = data.filter((e: any) => e.field !== 'ein');
    }

    return data;
  }


  onRadioChange(controlName: string, value: string) {
    if (value === 'Yes') {
      this.referralDataService.setFlowForAssociation({ val: true, flow: controlName });
    }
  }

  add(control: string) {
    this.referralDataService.setFlowForAssociation({ val: true, flow: control });
  }

  hideAll() {
    this.activeKeys = [];
  }

  expandAll() {
    this.activeKeys = ['1', '2', '3', '4', '5', '6', '7'];
  }

  togglePanel(key: string): void {
    if (this.isPanelActive(key)) {
      this.activeKeys = this.activeKeys.filter((k) => k !== key);
    } else {
      this.activeKeys.push(key);
    }
  }

  isPanelActive(key: string): boolean {
    return this.activeKeys.includes(key);
  }

  handleDialogCancel() {
    this.selectedAssociationId = '';
    this.selectedProviderId = '';
    this.selectedProviderType = '';
    this.selectedAssociationStartDate = '';
    this.handleCancel();
  }

  handleCancel() {
    this.showModal = false;
    this.modalBody = '';
    this.mode = 'read';
    this.showMoveToInPPLReviewButton = false;
    this.disableStatus = false;
  }

  save() {
    if (this.mode == 'add') {
      this.showStatusAddErrorMessage = false;
      const data = { ...this.enrollmentStatus.getRawValue() };

      data.startDate = this.dateFormatter.formatToString(data.startDate);

      if (data.endDate) {
        data.endDate = this.dateFormatter.formatToString(data.endDate);
      }

      try {
        this.validationErrors = performValidation(data, this.secData, 'Save', undefined, undefined, this.sectionsService.getFlow(), this.sectionsService.getEnrollmentType());

        // make the form controls as touched to show the validation errors in UI, irrespective of validation error exists or not, as the validations are performed on form submit.
        Object.keys(this.enrollmentStatus.controls).forEach(controlName => {
          this.enrollmentStatus.get(controlName)?.markAsTouched();
        });

      } catch (e) {
        this.logger.debug('Error in validations', e);
      }

      if (Object.keys(this.validationErrors).length === 0 && this.enrollmentStatus.valid) {
        if (this.isEmploymentDateStatus) {
          const employmentData = {
            providerId: this.selectedProviderId,
            startDate: data.startDate,
            comments: data.comment
          };
          this.enrollmentDataService
            .updateAssociationEmploymentDate(employmentData, this.program?.program_code)
            .subscribe(() => this.onStatusSaveSuccess());
        } else {
          this.enrollmentDataService
            .createEnrollmentStatus(data, this.program?.program_code, this.selectedAssociationId, true, this.statusAddErrorMessage)
            .subscribe((data: any) => {
              if (data.responsedata == this.statusAddErrorMessage && data.status == 200) {
                this.customErrorMessage = data.responsemsg[0].desc;
                this.showStatusAddErrorMessage = true;
                return;
              }

              this.onStatusSaveSuccess();
            });
        }
      }
    } else if (this.mode == 'edit') {
      this.updateStatus();
    }
  }

  updateStatus() {
    const formValues = this.enrollmentStatus.getRawValue();

    // Disassociated requires startDate on edit; block save and surface the inline error.
    if (this.isDisassociatedStatus(formValues.status) && !formValues.startDate) {
      this.validationErrors['startDate'] = 'Start Date is required';
      this.enrollmentStatus.get('startDate')?.markAsTouched();
      return;
    }

    const data: any = {};
    data.associationId = formValues.associationId;
    data.statusId = formValues.statusId;
    data.status = formValues.status;
    data.reason = formValues.reason;
    data.comment = formValues.comment;
    data.startDate = this.dateFormatter.formatToString(formValues.startDate);
    if (formValues.endDate) {
      data.endDate = this.dateFormatter.formatToString(formValues.endDate);
    }
    this.enrollmentDataService
      .updateEnrollmentStatus(data, this.program?.program_code, formValues.associationId, this.statusUpdateErrorMessage)
      .subscribe((response: any) => {
        if (response?.responsedata === this.statusUpdateErrorMessage && response?.status === 200) {
          this.customErrorMessage = response?.responsemsg?.[0]?.desc ?? 'An error occurred during edit status';
          this.showStatusAddErrorMessage = true;
          return;
        }

        this.showStatusAddErrorMessage = false;
        this.customErrorMessage = '';
        this.logger.info('Status information updated successfully');
        this.cancelEdit();
        this.getAssociationStatus();
        this.disableStatus = false;
        this.getAssociationDetails(this.program.program_code, this.leadId, false);
        this.handleCancel();
      });
  }

  moveToPPLReview(): void {
    this.allowedStatus = [
      {
        status: "In PPL Review"
      }
    ];

    this.addStatus();
    this.enrollmentStatus.patchValue({
      startDate: new Date(),
      status: 'In PPL Review'
    });
    this.disableStatus = true;
  }


  disabledStartDate = (startValue: Date): boolean => {
    const endDate = this.enrollmentStatus.get('endDate')?.value;
    if (!startValue || !endDate) {
      return false;
    }
    return startValue.getTime() > endDate.getTime();
  };

  updateMinStartDate(): void {
    const endDate = this.enrollmentStatus.get('endDate')?.value;
    if (endDate instanceof Date) {
      const nextDay = new Date(endDate);
      nextDay.setDate(nextDay.getDate() - 1);
      this.minStartDate = nextDay;
    } else {
      this.minStartDate = undefined;
    }
  }

  updateMaxEndDate(): void {
    const startDate = this.enrollmentStatus.get('startDate')?.value;
    if (startDate instanceof Date) {
      const nextDay = new Date(startDate);
      nextDay.setDate(nextDay.getDate() + 1);
      this.maxEndDate = nextDay;
    } else {
      this.maxEndDate = undefined;
    }
  }

  updateReasonList(status: string): void {
    if (this.isDisassociatedStatus(status)) {
      this.statusReasons = this.disAssociateReasonList;
    } else {
      this.statusReasons = this.generalReasonList;
    }
  }

  disabledEndDate = (endValue: Date): boolean => {
    const startDate = this.enrollmentStatus.get('startDate')?.value;
    if (!endValue || !startDate) {
      return false;
    }
    return endValue.getTime() <= startDate.getTime();
  };

  createFormGroup() {
    this.enrollmentStatus = this.fb.group({
      statusId: [],
      associationId: [],
      startDate: [],
      endDate: [],
      status: [],
      comment: [],
      reason: []
    });
  }

  addStatus() {
    this.showStatusAddErrorMessage = false;
    this.mode = 'add';
    this.enrollmentStatus.reset();
    this.enrollmentStatus.controls['associationId'].setValue(this.selectedAssociationId);
    this.refreshParticipantStatusFromLatest();
    this.updateStatusEntries();
  }

  private refreshParticipantStatusFromLatest() {
    if (!this.prvdrAssociationsStatus?.length) return;
    const latest = this.prvdrAssociationsStatus.reduce((acc: any, curr: any) =>
      new Date(curr.modifiedDate) > new Date(acc.modifiedDate) ? curr : acc
    );
    if (latest?.status) {
      this.participantStatus = latest.status;
    }
  }

  updateAssociationStatus(status: string) {
    this.participantStatus = status;

    this.showMoveToInPPLReviewButton = false;
    this.disableAddStatus = false;
    if ((environment.isExternal && this.userDetails?.usertype_lkp?.toLowerCase() != 'state')) {
      this.disableAddStatus = true;
    }

    this.isAssociationStatusEditable = this.authUtility.isSectionEditable(this.pageId, this.tabId, 'AssociationsStatus');
    if (!this.isAssociationStatusEditable) {
      this.disableAddStatus = true;
    }

    if (this.isAssociationStatusEditable && (this.participantStatus === 'Returned' || this.participantStatus === 'In Progress')) {
      this.showMoveToInPPLReviewButton = true;
    }

    this.updateStatusEntries();
  }

  onStatusSaveSuccess() {
    this.logger.info('Status information saved successfully');
    this.cancelEdit();
    this.getAssociationStatus();
    this.disableStatus = false;
    this.getAssociationDetails(this.program.program_code, this.leadId, true);
    this.handleCancel();
    setTimeout(() => {
      if (this.addStatusBtn?.nativeElement) {
        this.addStatusBtn.nativeElement.focus();
      }
    }, 0);
  }

  cancelEdit() {
    this.mode = 'read';
    this.showStatusAddErrorMessage = false;
    this.validationErrors = {};
    this.enrollmentStatus.reset();
    this.enrollmentStatus.get('endDate')?.enable();
    this.enrollmentStatus.get('reason')?.enable();
    this.enrollmentStatus.get('startDate')?.enable();
    this.isEmploymentDateStatus = false;
    this.disableStatus = false;
  }

  isDisassociatedStatus(status: string): boolean {
    return status === 'Disassociated' || status === 'Disassociate';
  }

  getLatestDisassocStartDate(): Date | null {
    const disassocEntries = (this.prvdrAssociationsStatus ?? [])
      .filter((r: any) => this.isDisassociatedStatus(r.status));
    if (!disassocEntries.length) return null;
    const latest = disassocEntries.reduce((acc: any, curr: any) =>
      new Date(curr.modifiedDate) > new Date(acc.modifiedDate) ? curr : acc
    );
    if (!latest?.startDate) return null;
    const [y, m, d] = latest.startDate.split('-').map(Number);
    return new Date(y, m - 1, d);
  }

  updateStatusEntries() {
    if (this.participantStatus === 'Registration Inactive') {
      this.allowedStatus = this.statusEntries.filter(s => s.lkpValueCode === 'In PPL Review');
      return;
    }

    const isCurrentDisassoc = this.isDisassociatedStatus(this.participantStatus);
    this.allowedStatus = this.statusEntries.filter(s => {
      if (isCurrentDisassoc) {
        return !this.isDisassociatedStatus(s.lkpValueCode);
      }
      return s.lkpValueCode != this.participantStatus;
    });

    if (isCurrentDisassoc) {
      const start = this.getLatestDisassocStartDate();
      if (start) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const diffDays = Math.floor((today.getTime() - start.getTime()) / (1000 * 60 * 60 * 24));
        const keepName = diffDays < STATIC_DATA.RESTORE_REHIRE_THRESHOLD_DAYS ? STATIC_DATA.ASSOCIATION_RESTORE_STATUS : STATIC_DATA.ASSOCIATION_REHIRE_STATUS;

        this.allowedStatus = this.allowedStatus.filter((s: any) =>
          (s.lkpValueName !== STATIC_DATA.ASSOCIATION_RESTORE_STATUS && s.lkpValueName !== STATIC_DATA.ASSOCIATION_REHIRE_STATUS) || s.lkpValueName === keepName
        );
      }
    } else {
      this.allowedStatus = this.allowedStatus.filter((s: any) => s.lkpValueName !== STATIC_DATA.ASSOCIATION_RESTORE_STATUS && s.lkpValueName !== STATIC_DATA.ASSOCIATION_REHIRE_STATUS);
    }
  }
}
